/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";
import "./sign-in.scss";
// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import SignInImg from "../../../../src/assets/images/065759206512449.66ce05c7449fc.jpg";

import { getAuth, signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import { Route, Redirect, Navigate, RouteComponent } from "react-router-dom";
import { Button } from "@mui/material";

function Basic() {
  const [Email, SetEmail] = useState("");
  const [Password, SetPassword] = useState("");
  const [ErrorText, SetErrorText] = useState("");

  const [GoHome, SetGoHome] = useState(false);

  const auth = getAuth();
  const [user, loading, error] = useAuthState(auth);

  useEffect(() => {
    console.log(user, loading);
    if (user) {
      SetGoHome(true);
    }
  }, [user, loading]);

  const onSubmit = () => {
    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );

    if (!pattern.test(Email)) {
      SetErrorText("لو سمحت أدخل بريد إليكتروني صالح");
      return;
    }
    if (Password.length < 6) {
      SetErrorText("يجب أن تتكون كلمة المرور من 6 أحرف على الأقل");
      return;
    }

    signInWithEmailAndPassword(auth, Email, Password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        SetGoHome(true);
        // ...
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        SetErrorText(errorMessage);
      });
  };

  const ForgotPassword = () => {
    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );

    if (!pattern.test(Email)) {
      SetErrorText("لو سمحت أدخل بريد إليكتروني صالح");
      return;
    }
    sendPasswordResetEmail(auth, Email)
      .then(() => {
        SetErrorText(
          "An Email has been sent to you! Please check your junk folder if you can't find our email."
        );
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        SetErrorText(errorMessage);
        // ..
      });
  };

  const [rememberMe, setRememberMe] = useState(false);

  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission
    onSubmit(); // Call your existing submit function
  };

  return (
    <BasicLayout>
      {GoHome && <Navigate to="/dashboard" />}
      <div className="sign-in-container">
        <div
          className="sign-in-img"
          style={{
            backgroundImage: `url(${SignInImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "60vh",
          }}
        ></div>
        <div className="sign-in-card">
          <Card className="sign-in-info">
            <MDBox
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              mx={2}
              mt={-3}
              p={2}
              mb={1}
              textAlign="center"
            >
              <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                Sign in
              </MDTypography>
              {/* <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <FacebookIcon color="inherit" />
              </MDTypography>
            </Grid>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <GitHubIcon color="inherit" />
              </MDTypography>
            </Grid>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <GoogleIcon color="inherit" />
              </MDTypography>
            </Grid>
          </Grid> */}
            </MDBox>
            <MDBox pt={4} pb={3} px={3}>
              <MDBox component="form" role="form" onSubmit={handleSubmit}>
                <MDBox mb={2}>
                  <MDInput
                    onChange={(e) => SetEmail(e.target.value)}
                    type="email"
                    label="Email"
                    fullWidth
                    onKeyPress={(e) => e.key === "Enter" && handleSubmit(e)}
                  />
                </MDBox>
                <MDBox mb={2}>
                  <MDInput
                    onChange={(e) => SetPassword(e.target.value)}
                    type="password"
                    label="Password"
                    fullWidth
                    onKeyPress={(e) => e.key === "Enter" && handleSubmit(e)}
                  />
                </MDBox>

                <MDBox mt={4} mb={1}>
                  <MDTypography variant="overline" color={"error"}>
                    {ErrorText}
                  </MDTypography>
                </MDBox>
                <MDBox mt={4} mb={1}>
                  <MDButton onClick={() => onSubmit()} variant="gradient" color="info" fullWidth>
                    sign in
                  </MDButton>
                </MDBox>
                {/*  <MDBox mt={3} mb={1} textAlign="center">
                  <MDTypography variant="button" color="text">
                    Don&apos;t have an account?{" "}
                    <MDTypography
                      component={Link}
                      to="/authentication/sign-up"
                      variant="button"
                      color="info"
                      fontWeight="medium"
                      textGradient
                    >
                      Sign up
                    </MDTypography>
                  </MDTypography>
                </MDBox> */}

                <MDBox mt={3} mb={1} textAlign="center">
                  <MDTypography variant="button" color="text">
                    Forgot Password?{" "}
                    <MDTypography
                      component={Button}
                      onClick={() => ForgotPassword()}
                      variant="button"
                      color="info"
                      fontWeight="medium"
                      textGradient
                    >
                      Send Password Reset Email
                    </MDTypography>
                  </MDTypography>
                </MDBox>
              </MDBox>
            </MDBox>
          </Card>
        </div>
      </div>
    </BasicLayout>
  );
}

export default Basic;
